import type { User } from "@maeiz/core";

function str(value: unknown): string | undefined {
    return value != null && String(value).length > 0 ? String(value) : undefined;
}

const PLATFORM_CONSOLE_ROLES = ["owner", "platform_staff", "associate"] as const;

export function isPlatformConsoleRole(role: string | undefined): boolean {
    return PLATFORM_CONSOLE_ROLES.some((r) => r === role);
}

export function normalizeUser(raw: Record<string, unknown>): User {
    const platformRole = (raw.platformRole ?? raw.platform_role) as
        User["platformRole"] | undefined;
    return {
        id: raw.id as string | number,
        name: String(raw.name ?? ""),
        email: str(raw.email),
        phone: str(raw.phone),
        role: (raw.role as User["role"]) || "owner",
        profilePicture: ((raw.profilePicture ?? raw.profile_picture) as string | null) ?? null,
        planId: ((raw.planId ?? raw.plan_id) as string | number | null) ?? null,
        plan: (raw.plan as User["plan"]) ?? null,
        tenantId: ((raw.tenantId ?? raw.tenant_id) as string | null) ?? null,
        tenant: (raw.tenant as User["tenant"]) ?? null,
        companyName: str(raw.companyName ?? raw.company_name) ?? null,
        city: str(raw.city) ?? null,
        address: str(raw.address) ?? null,
        platformRoleId:
            ((raw.platformRoleId ?? raw.platform_role_id) as string | null | undefined) ?? null,
        platformRole: platformRole ?? null,
    };
}
